import { useState, useEffect } from 'react'

// Global state for synchronized countdown
let globalTimeLeft = 10 * 60 + 43 // 10:43 in seconds
let listeners: React.Dispatch<React.SetStateAction<number>>[] = []
let intervalId: NodeJS.Timeout | null = null

const startInterval = () => {
  if (!intervalId) {
    intervalId = setInterval(() => {
      globalTimeLeft -= 1
      if (globalTimeLeft < 0) globalTimeLeft = 0
      listeners.forEach((listener) => listener(globalTimeLeft))
    }, 1000)
  }
}

export function useCountdown() {
  const [timeLeft, setTimeLeft] = useState(globalTimeLeft)

  useEffect(() => {
    listeners.push(setTimeLeft)
    startInterval()

    return () => {
      listeners = listeners.filter((l) => l !== setTimeLeft)
      if (listeners.length === 0 && intervalId) {
        clearInterval(intervalId)
        intervalId = null
      }
    }
  }, [])

  const hours = Math.floor(timeLeft / 3600)
  const minutes = Math.floor((timeLeft % 3600) / 60)
  const seconds = timeLeft % 60

  return {
    hours: hours.toString().padStart(2, '0'),
    minutes: minutes.toString().padStart(2, '0'),
    seconds: seconds.toString().padStart(2, '0'),
  }
}
